import React from 'react';

interface Part {
    id: number;
    name: string;
    quantity: number;
}

interface PartsListProps {
    parts?: Part[];
}

const PartsList: React.FC<PartsListProps> = ({ parts = [] }) => {
    return (
        <div>
            <h2>Parts List</h2>
            <ul>
                {parts.map(part => (
                    <li key={part.id}>
                        {part.name} - Quantity: {part.quantity}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PartsList;